import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { HttpStatus } from 'enums'

import { paveApi } from 'api'
import BreadcrumbBar from 'components/common/BreadcrumbBar/BreadcrumbBar'
import { PageLayout } from 'components/partials'
import PaveSecuritiesFooter from 'components/partials/PaveSecuritiesFooter'
import PortfolioPageContent from 'components/partials/Portfolio/V2/PortfolioPageContent'
import PDSBanner from 'designSystem/components/PDSBanner/PDSBanner'
import PDSBox from 'designSystem/components/PDSBox/PDSBox'
import PDSFlexBox from 'designSystem/components/PDSFlexBox/PDSFlexBox'
import PDSIcon from 'designSystem/components/PDSIcon/PDSIcon'
import PDSText from 'designSystem/components/PDSText/PDSText'
import { SIZE } from 'designSystem/foundations/constants/size'
import { getPortfolioBanner } from 'utils/portfolioUtil'

export default function PortfolioPageV2() {
  const { externalId } = useParams()
  const navigate = useNavigate()

  // Queries
  const { useGetPortfolioQuery } = paveApi
  const {
    data: portfolio,
    isLoading: isPortfolioLoading,
    isFetching: isPortfolioFetching,
    error: pageQueryError,
  } = useGetPortfolioQuery(externalId || '')
  const { data: clientAccountData } = paveApi.useGetClientAccountQuery(
    portfolio?.clientAccountId || '',
    {
      skip: !portfolio?.clientAccountId,
    }
  )

  const currentOrganization = portfolio?.clientAccount?.managementOrganizationId
  const breadcrumbs = [
    {
      name: 'Home Page',
      route: `/organization/${currentOrganization}`,
    },
    {
      name: clientAccountData?.clientAccount?.displayName || 'Group Overview',
      route: `/account/${portfolio?.clientAccountId || ''}`,
    },
    {
      name: portfolio?.displayName || 'Portfolio Overview',
      route: `/portfolio/${portfolio?.id || ''}`,
    },
  ]

  useEffect(() => {
    if ((pageQueryError as any)?.data?.statusCode === HttpStatus.FORBIDDEN) {
      navigate('/forbidden')
    }
  }, [navigate, pageQueryError])

  let content = null

  if (!portfolio) {
    content = (
      <PDSBox>
        <PDSText>There's an issue loading this portfolio</PDSText>
      </PDSBox>
    )
  } else {
    content = <PortfolioPageContent portfolio={portfolio} />
  }

  const banner = getPortfolioBanner(portfolio)

  return (
    <PageLayout
      footer={<PaveSecuritiesFooter />}
      showLoader={isPortfolioFetching || isPortfolioLoading}
      showNewLayout={true}
      subHeader={
        <>
          <BreadcrumbBar paths={breadcrumbs} />
          {banner && (
            <PDSBanner showClose={true} variant={banner.variant}>
              <PDSFlexBox alignItems="center" gap={SIZE.s8}>
                <PDSIcon color={banner.iconColor} name={banner.iconName} />
                <PDSText weight="semibold">{banner.text}</PDSText>
              </PDSFlexBox>
            </PDSBanner>
          )}
        </>
      }
    >
      {content}
    </PageLayout>
  )
}
